export enum TiposJuegos{
    cartas = '1',
    binario = '2',
    decimal = '3'
}